import React from 'react';
import MobileNavigation from './MobileNavigation';

interface MobileLayoutOptimizedProps {
  children: React.ReactNode;
}

const MobileLayoutOptimized: React.FC<MobileLayoutOptimizedProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Contenu principal avec padding bottom pour la navigation mobile */}
      <div className="pb-20 md:pb-6">
        {children}
      </div>
      
      {/* Navigation mobile - toujours en bas */}
      <MobileNavigation />
    </div>
  );
};

export default MobileLayoutOptimized;
